import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";

export default function shouldInitializeSearch(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("sea-clientWarmup") ||
        isAccountFeatureEnabled("sea-gwc-real-time-search-matching-no-ranking", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-outlook-infra-shadow-mode", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-entity", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-with-7-results", mailboxInfo));
}
